import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import type { IconName } from '@hotjar/hotsauce';
import { DropdownMenu, Icon, Badge, tokens } from '@hotjar/hotsauce';
import type { DropdownBaseItemProps } from '@hotjar/hotsauce';

export type ItemWithCounterProps = DropdownBaseItemProps & {
  children: string;
  count?: number | string;
  icon?: IconName;
};

const IconWrapper = styled.span`
  flex-shrink: 1;
  margin-right: ${tokens.spacer.x1};
`;

const TextWrapper = styled.span`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
`;

const CounterWrapper = styled.span`
  flex-shrink: 1;
  margin-left: ${tokens.spacer.x1};
`;

const badgeStyles = css`
  border: 1px solid ${tokens.ALIAS_COLORS.ui_border_danger};
  line-height: 1;
  padding: 1px 2px;
`;

export const ItemWithCounter = forwardRef<HTMLLIElement, ItemWithCounterProps>(
  ({ children, count, icon, ...props }: ItemWithCounterProps, ref): JSX.Element => (
    // FIXME: [CUX-58] css prop should not be incompatible
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <DropdownMenu.BaseItem {...props} ref={ref}>
      {icon && (
        <IconWrapper data-testid="item-with-counter-icon">
          <Icon icon={icon} size="m" />
        </IconWrapper>
      )}
      <TextWrapper>{children}</TextWrapper>
      {typeof count !== 'undefined' && (
        <CounterWrapper data-testid="item-with-counter-counter">
          <Badge
            kind="custom"
            size="s"
            color={tokens.BRAND_COLORS.ember_100}
            textColor={tokens.ALIAS_TEXT_COLORS.text_danger}
            css={badgeStyles}
          >
            {`${count}`}
          </Badge>
        </CounterWrapper>
      )}
    </DropdownMenu.BaseItem>
  ),
);

ItemWithCounter.displayName = 'ItemWithCounter';
